export enum CertificationStandardEnum {
    // --- ISO ---
    ISO9001 = 1,
    ISO13485 = 2,
    ISO14001 = 3,
    ISO45001 = 4,
    ISO_IEC_27001 = 5,

    // --- GxP / regulacje ---
    GMP_cGMP = 100,
    GAMP5 = 101,
    CFR21_Part11 = 102,
    EU_Annex_11 = 103,
    FDA = 104,

    // --- Znaki zgodności ---
    CE = 200,
    ATEX = 201,
    PED = 202,
    UKCA = 203,
    UL_CSA = 204,
}

export function certCategory(code: number) {
    if (code < 100) return "ISO";
    if (code < 200) return "GxP";
    return "Conformity";
}

// === Etykiety (Display(Name=...)) ===
export const CERTIFICATION_LABEL: Record<CertificationStandardEnum, string> = {
    [CertificationStandardEnum.ISO9001]: "ISO 9001",
    [CertificationStandardEnum.ISO13485]: "ISO 13485",
    [CertificationStandardEnum.ISO14001]: "ISO 14001",
    [CertificationStandardEnum.ISO45001]: "ISO 45001",
    [CertificationStandardEnum.ISO_IEC_27001]: "ISO/IEC 27001",

    [CertificationStandardEnum.GMP_cGMP]: "GMP/cGMP",
    [CertificationStandardEnum.GAMP5]: "GAMP 5",
    [CertificationStandardEnum.CFR21_Part11]: "21 CFR Part 11",
    [CertificationStandardEnum.EU_Annex_11]: "EU Annex 11",
    [CertificationStandardEnum.FDA]: "FDA",

    [CertificationStandardEnum.CE]: "CE",
    [CertificationStandardEnum.ATEX]: "ATEX",
    [CertificationStandardEnum.PED]: "PED",
    [CertificationStandardEnum.UKCA]: "UKCA",
    [CertificationStandardEnum.UL_CSA]: "UL/CSA",
} as const;

type ChipColor =
    | "default" | "primary" | "secondary" | "success" | "info" | "warning" | "error";


export const CERT_COLOR: Partial<Record<CertificationStandardEnum, ChipColor>> = {
    [CertificationStandardEnum.ISO9001]: "success",
    [CertificationStandardEnum.ISO13485]: "success",
    [CertificationStandardEnum.ISO14001]: "success",
    [CertificationStandardEnum.ISO45001]: "success",
    [CertificationStandardEnum.ISO_IEC_27001]: "success",

    [CertificationStandardEnum.GMP_cGMP]: "info",
    [CertificationStandardEnum.GAMP5]: "info",
    [CertificationStandardEnum.CFR21_Part11]: "info",
    [CertificationStandardEnum.EU_Annex_11]: "info",
    [CertificationStandardEnum.FDA]: "info",

    [CertificationStandardEnum.CE]: "warning",
    [CertificationStandardEnum.ATEX]: "warning",
    [CertificationStandardEnum.PED]: "warning",
    [CertificationStandardEnum.UKCA]: "warning",
    [CertificationStandardEnum.UL_CSA]: "warning",
};

// === Helper: bezpieczna etykieta do UI ===
export const certificationLabel = (
    v?: number | CertificationStandardEnum | null
): string => (v != null ? CERTIFICATION_LABEL[v as CertificationStandardEnum] ?? "—" : "—");

// === Opcje do Select/Autocomplete ===
export const CERTIFICATION_OPTIONS: ReadonlyArray<{
    value: CertificationStandardEnum;
    label: string;
}> = (Object.values(CertificationStandardEnum) as Array<number>)
    .filter((v): v is number => typeof v === "number")
    .map((value) => ({ value, label: CERTIFICATION_LABEL[value as CertificationStandardEnum] }));

// (opcjonalnie) Normalizacja, gdy czasem dostaniesz string z API ("ISO9001")
export const normalizeCertification = (
    v: number | string | null | undefined
): CertificationStandardEnum | undefined => {
    if (v == null) return undefined;
    if (typeof v === "number") return v as CertificationStandardEnum;
    const num = (CertificationStandardEnum as any)[v]; // reverse mapping TS enum
    return typeof num === "number" ? (num as CertificationStandardEnum) : undefined;
};
